<template><div><code-example only-show="demo">
<dt-text kind="body" :size="300">
  <dt-emoji-text-wrapper>
    Some text with :invalid-emoji: :smile: :cry: and 😄, and custom emojis :octocat: :shipit:
  </dt-emoji-text-wrapper>
</dt-text>
</code-example>
<!-- <component-combinator component-name="DtEmojiTextWrapper" /> -->
<h2 id="variants-and-examples" tabindex="-1" class="d-docsite--header-2">Variants and Examples <a class="header-anchor d-link d-docsite--link d-link" href="#variants-and-examples" aria-hidden="true">#</a></h2>
<h3 id="text-only" tabindex="-1" class="d-docsite--header-3">Text Only <a class="header-anchor d-link d-docsite--link d-link" href="#text-only" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-text kind=&quot;body&quot; :size=&quot;300&quot;&gt;
  &lt;dt-emoji-text-wrapper&gt;
    Some text with :invalid-emoji: :smile: :cry: and 😄, and custom emojis :octocat: :shipit:
  &lt;/dt-emoji-text-wrapper&gt;
&lt;/dt-text&gt;'>
<dt-text kind="body" :size="300">
  <dt-emoji-text-wrapper>
    Some text with :invalid-emoji: :smile: :cry: and 😄, and custom emojis :octocat: :shipit:
  </dt-emoji-text-wrapper>
</dt-text>
</code-example>
<h3 id="variants" tabindex="-1" class="d-docsite--header-3">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h3>
<code-example source-code='&lt;dt-button&gt;
  &lt;dt-emoji-text-wrapper&gt;
    Button with shortcode :cry: emoji
  &lt;/dt-emoji-text-wrapper&gt;
&lt;/dt-button&gt;
&lt;dt-text kind=&quot;body&quot; :size=&quot;300&quot;&gt;
  &lt;dt-emoji-text-wrapper&gt;
    Text only with unicode 😃 emoji
  &lt;/dt-emoji-text-wrapper&gt;
&lt;/dt-text&gt;
&lt;dt-button&gt;
  &lt;dt-emoji-text-wrapper&gt;
    Button wrapper :smile:
  &lt;/dt-emoji-text-wrapper&gt;
&lt;/dt-button&gt;
&lt;dt-text kind=&quot;body&quot; :size=&quot;300&quot;&gt;
  &lt;dt-emoji-text-wrapper size=&quot;800&quot;&gt;
    Bigger emoji size :smile:
  &lt;/dt-emoji-text-wrapper&gt;
&lt;/dt-text&gt;
&lt;dt-text kind=&quot;body&quot; :size=&quot;300&quot;&gt;
  &lt;dt-emoji-text-wrapper size=&quot;300&quot;&gt;
    Smaller emoji size :smile:
  &lt;/dt-emoji-text-wrapper&gt;
&lt;/dt-text&gt;'>
<dt-stack data-demo-wrapper gap="200">
  <dt-button>
    <dt-emoji-text-wrapper>
      Button with shortcode :cry: emoji
    </dt-emoji-text-wrapper>
  </dt-button>
  <dt-text kind="body" :size="300">
    <dt-emoji-text-wrapper>
      Text only with unicode 😃 emoji
    </dt-emoji-text-wrapper>
  </dt-text>
  <dt-button>
    <dt-emoji-text-wrapper>
      Button wrapper :smile:
    </dt-emoji-text-wrapper>
  </dt-button>
  <dt-text kind="body" :size="300">
    <dt-emoji-text-wrapper size="800">
      Bigger emoji size :smile:
    </dt-emoji-text-wrapper>
  </dt-text>
  <dt-text kind="body" :size="300">
    <dt-emoji-text-wrapper size="300">
      Smaller emoji size :smile:
    </dt-emoji-text-wrapper>
  </dt-text>
</dt-stack>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="emojitextwrapper" /><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<h3 id="import" tabindex="-1" class="d-docsite--header-3">Import <a class="header-anchor d-link d-docsite--link d-link" href="#import" aria-hidden="true">#</a></h3>
<div class="language-javascript" data-highlighter="prismjs" data-ext="js"><pre v-pre><code class="language-javascript"><span class="line"><span class="token keyword">import</span> <span class="token punctuation">{</span> DtEmojiTextWrapper <span class="token punctuation">}</span> <span class="token keyword">from</span> <span class="token string">'@dialpad/dialtone-vue'</span><span class="token punctuation">;</span></span>
<span class="line"></span></code></pre>
</div><h3 id="limitations" tabindex="-1" class="d-docsite--header-3">Limitations <a class="header-anchor d-link d-docsite--link d-link" href="#limitations" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Currently, this wrapper component <strong>can't handle Vue components</strong>, make sure to wrap only native HTML elements and text.</p>
<h3 id="custom-emojis" tabindex="-1" class="d-docsite--header-3">Custom Emojis <a class="header-anchor d-link d-docsite--link d-link" href="#custom-emojis" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">It supports custom emojis, you can use the shortcode to display them. For example, <code v-pre>:octocat:</code> will render the octocat emoji.
To do this, you need to <RouteLink to="/components/emoji.html#custom-emoji" class="d-docsite--link d-link">set up custom emojis</RouteLink> in your application.</p>
</div></template>


